import React from 'react';
import styled from 'styled-components';
import { Heading } from '../styles/components';
import Tag from './Tag';

const SectionWrapper = styled.section`
  padding: ${props => props.theme.spacing.xxl} 0;
`;

const ContentCard = styled.div`
  background-color: ${props => props.theme.colors.dark.background};
  border-radius: ${props => props.theme.radii.card};
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: ${props => props.theme.spacing.xxl} 0;
  color: ${props => props.theme.colors.dark.text};
`;

const ContentInner = styled.div`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.containerPadding};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${props => props.theme.spacing.xl};
  margin-top: ${props => props.theme.spacing.xl};

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.radii.card};
  padding: ${props => props.theme.spacing.xl};
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled.h3`
  font-family: ${props => props.theme.typography.heading.fontFamily};
  font-size: ${props => props.theme.typography.sizes.h4};
  color: ${props => props.theme.colors.text};
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: ${props => props.theme.spacing.xl};
  border-radius: ${props => props.theme.radii.sm};
  border: ${props => props.theme.colors.secondary} 1px solid;
`;

const FeatureList = styled.ul`
  ${({ theme }) => theme.lists.bullet.style};
  margin: 0;
  
  li {
    margin-bottom: ${({ theme }) => theme.lists.bullet.spacing};
    font-size: ${({ theme }) => theme.lists.bullet.fontSize};
    line-height: ${({ theme }) => theme.lists.bullet.lineHeight};
    color: ${props => props.theme.colors.text};
  }
`;

const DarkTag = styled(Tag)`
  color: ${props => props.theme.colors.brand};
  svg {
    color: ${props => props.theme.colors.brand};
  }
`;

const ToolsSection = () => {
  return (
    <SectionWrapper>
      <ContentCard>
        <ContentInner>
          <DarkTag>THE TRUE AI ADVANTAGE FOR SMALL BUSINESS</DarkTag>
          <Heading as="h2" color="white">Get more than piecemeal, siloed tools</Heading>
          
          <Grid>
            <Card>
            <CardTitle>
                🤖 More than an AI writer
              </CardTitle>
              <CardImage src="/assets/aiwriter.webp" alt="AI Writer illustration" />
              <FeatureList>
                <li>Your strategy powers your content - no more random prompts or repetitive context-pasting</li>
                <li>Content adapts instantly when you update your strategy</li>
                <li>Maintains your unique voice while drawing from your entire business context</li>
                <li>Generate targeted content that aligns with your goals, audience and offers</li>
              </FeatureList>
            </Card>

            <Card>
            <CardTitle>
                🧠 More than a 'second brain'
              </CardTitle>
                            <CardImage src="/assets/secondbrain.webp" alt="Second brain illustration" />
              <FeatureList>
                <li>Second brains are for storage. In Moogul, your strategy and knowledge becomes active, not archived</li>
                <li>Everything connects and works together</li>
                <li>Update once, see changes everywhere</li>
                <li>Turn knowledge into growth 24/7</li>
              </FeatureList>
            </Card>

            <Card>
            <CardTitle>
                💼 More than a Custom GPT
              </CardTitle>
                            <CardImage src="/assets/customgpt.webp" alt="Custom GPT illustration" />

              <FeatureList>
                <li>Stop scattering your strategy across multiple AI tools</li>
                <li>Access multiple AI models for optimal results</li>
                <li>Your strategy automatically creates targeted prompts</li>
                <li>Keep brand voice consistent as your business evolves</li>
                <li>Single source of truth - no more out-of-date knowledge bases</li>
              </FeatureList>
            </Card>
          </Grid>
        </ContentInner>
      </ContentCard>
    </SectionWrapper>
  );
};

export default ToolsSection; 